  <template>
    <div ref="languageModalWrapper">
      <div class="modal fade" id="languageModal" tabindex="-1" aria-labelledby="languageModalLabel" aria-hidden="true" data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
          <div class="modal-dialog modal-sm modal-dialog-centered language-modal-dialog">
              <div class="modal-content language-modal-content" style="background-color: rgba(60,60,60,.95); width:270px; height: 233.3px;">
                  <div class="modal-header2 p-6">
                      <h6 class="modal-title w-100 font-weight-bold text-left" id="exampleModalLabel">Cambiar Idioma
                          <button id="closeLanguageModal" :style="skin.my_account.close_btn" type="button" class="btn-close language-close-btn" data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times"></i></button>
                      </h6>
                  </div>
                  <div class="modal-body language-modal-body p-0">
                      <div class="language-selector-block">
                          <div ref="languageDropdown" class="language-dropdown" :class="{ open: isDropdownOpen }">
                          <button
                              type="button"
                              class="language-trigger"
                              :class="{ 'language-trigger-selected': hasLanguageSelection || isDropdownOpen }"
                              @click.stop="toggleDropdown"
                              :aria-expanded="isDropdownOpen ? 'true' : 'false'"
                          >
                              <span :class="{ placeholder: !hasLanguageSelection && !isDropdownOpen, 'trigger-label-selected': hasLanguageSelection, 'trigger-label-open': isDropdownOpen && !hasLanguageSelection }">
                                  {{ selectedLabel }}
                              </span>
                          </button>
                              <div v-if="isDropdownOpen" class="language-menu">
                              <button
                                  v-for="(lang, key) in enabledLanguages"
                                  :key="key"
                                  type="button"
                                  class="language-option"
                                  @click="selectLanguage(key)"
                              >
                                  <span>{{ getDisplayLanguageName(lang.name) }}</span>
                                  <span :class="['phoca-flag', getFlagClass(key)]" class="language-flag"></span>
                              </button>
                          </div>
                          </div>
                      </div>
                      <div class="text-center language-close-wrap">
                          <button class="close-btn" data-bs-dismiss="modal">CERRAR</button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
      name:"languageJm",
      props:['skin','translation','language'],
      data(){
          return {
            selectedLanguage: null,
            isDropdownOpen: false
          }
      },
      computed:{
        enabledLanguages() {
            const langs = this.skin?.languages || {};
            return Object.keys(langs).reduce((acc, key) => {
                if (langs[key]?.enabled) acc[key] = langs[key];
                return acc;
            }, {});
        },
        hasLanguageSelection() {
            return !!this.selectedLanguage;
        },
        selectedLabel() {
            if (!this.selectedLanguage) return 'Seleccionar';
            return this.getDisplayLanguageName(this.enabledLanguages[this.selectedLanguage]?.name) || 'Seleccionar';
        }
      },
      mounted() {
        document.addEventListener('click', this.handleOutsideClick);
      },
      beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick);
      },
      methods:{
          toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
          },
          selectLanguage(languageKey) {
            this.selectedLanguage = languageKey;
            this.isDropdownOpen = false;
            this.applyLanguage();
          },
          getFlagClass(languageKey) {
            const flagClasses = {
              es: 'es',
              en: 'us',
              pt: 'br'
            };

            return flagClasses[languageKey] || 'es';
          },
          getDisplayLanguageName(languageName) {
            if (!languageName) return '';

            const normalizedName = languageName.includes('-')
              ? languageName.split('-').slice(1).join('-').trim()
              : languageName.trim();

            return normalizedName.split(/\s+/)[0];
          },
          handleOutsideClick(event) {
            if (!this.$refs.languageDropdown?.contains(event.target)) {
              this.isDropdownOpen = false;
            }
          },
          applyLanguage() {
            if (!this.selectedLanguage) return;
            this.$store.dispatch('setLanguage', this.selectedLanguage);
          }
      }
  }
  </script>
  
  <style scoped>
  .language-modal-content{
      border: 0;
      border-radius: 0;
      overflow: visible;
      display: flex;
      flex-direction: column;
      margin-top: 1.25rem;
  }
  .language-modal-dialog{
      margin: 0 auto;
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
  }
  .modal-header2 {
      flex: 0 0 60px;
      height: 60px;
      width: 243px;
      margin: -1.25rem auto 0 auto;
      padding: 0 !important;
      color: #fff;
      border-bottom: none;
      background:linear-gradient(40deg,#292d3d,#03040d)!important;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      position: relative;
      z-index: 2;
      box-shadow: 0 5px 11px 0 rgba(0, 0, 0, .18), 0 4px 15px 0 rgba(0, 0, 0, .15);
  }
  .modal-title{
      width: 100%;
      margin: 0;
      color: #ffffff;
      font-family: "Metropolis regular", sans-serif;
      font-size: 16px;
      font-weight: 600;
      line-height: 16px;
      text-align: left;
      position: relative;
      padding: 16px 44px 16px 16px;
      min-height: 100%;
      display: flex;
      align-items: center;
      box-sizing: border-box;
  }
  .language-close-btn{
      position: absolute;
      top: 50%;
      right: 8px;
      transform: translateY(-50%);
      background: transparent;
      border: 0;
      padding: 0;
      margin: 0;
      color: #ffffff !important;
      opacity: 1;
      float: none !important;
  }
  .language-close-btn:focus{
      box-shadow: none;
  }
  .language-close-btn i{
      color: #ffffff;
      font-size: 16px;
  }
  .language-dropdown{
      position:relative;
      width: 162px;
      margin: 0 auto;
  }
  .language-modal-body{
      height: 193.3px;
      flex: 0 0 193.3px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
  }
  .language-selector-block{
      height: 119px;
      flex: 0 0 119px;
      width: 100%;
      font-family: "Metropolis", sans-serif;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      padding-top: 30px;
      box-sizing: border-box;
  }
  .language-trigger{
      width: 100%;
      min-height: 44px;
      border: 0;
      padding: 0 0 8px;
      background: transparent;
      color: #fff;
      font-size: 16px;
      font-weight: 500;
      text-align: left;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-shadow: none;
      border-bottom: 1px solid rgba(255,255,255,.45);
  }
  .language-trigger::after{
      content: '';
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid rgba(255,255,255,.9);
      margin-left: 12px;
      flex-shrink: 0;
  }
  .language-trigger .placeholder{
      color: #fff;
  }
  .language-trigger-selected{
      min-height: 56px;
      padding: 0 16px;
      background: #d9d9d9;
      color: #1f1f1f;
      font-size: 16px;
      border-bottom: 0;
  }
  .language-trigger-selected::after{
      border-top-color: #6f6f6f;
  }
  .trigger-label-selected{
      color: #1f1f1f;
  }
  .trigger-label-open{
      color: #8d8d8d;
  }
  .language-menu{
      position: absolute;
      top: 100%;
   
      left: 0;
      width: 100%;
      background: #d9d9d9;
      box-shadow: none;
      z-index: 10;
  }
  .language-option{
      width: 100%;
      border: 0;
      background: transparent;
      color: #1f1f1f;
   font-size: 16px;
      font-weight: 500;
      font-family: "Metropolis", sans-serif;

      font-size: 16px;
      padding: 10px 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: left;
  }
  .language-option:hover{
      background: rgba(255,255,255,.25);
  }
  .language-flag{
      width: 26px;
      height: 18px;
      flex-shrink: 0;
  }
  .close-btn{
      border:0;
      border-radius:1px;
      padding:13px 16px;
      color:#fff !important;
      background:#292d3d;
      margin: 0;
      font-size: 13px;
      font-family: "Metropolis", sans-serif;
      font-weight: 500;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
  }
  .close-btn,
  .close-btn:hover,
  .close-btn:focus,
  .close-btn:active{
      color: #ffffff !important;
  }
  .language-close-wrap{
      height: 74.3px;
      flex: 0 0 60px;
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      padding-bottom: 8px;
      box-sizing: border-box;
  }
  </style>
